module.exports = __webpack_public_path__ + "img/vegetable-celery-190x100.260045d1.jpg";